module.exports = __webpack_public_path__ + "img/navbar.c3a7c94e.svg";